import { OnInit, Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { META_TAG } from 'src/app/core/const/meta_tag';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss'],
})
export class AboutUsComponent implements OnInit {
  onNavigateRejoindre() {
    window.open('https://thedoorman-recrute.fr/', '_blank', 'noopener,noreferrer');
  }

  constructor(private meta: Meta, private title: Title) {}

  ngOnInit() {
    this.title.setTitle(META_TAG.concept.title);
    this.meta.updateTag({
      name: 'description',
      content: META_TAG.concept.description,
    });
    this.meta.updateTag({
      name: 'og:description',
      content: META_TAG.concept.description,
    });
  }
}
